"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiPaginationItem = void 0;
var typography_1 = require("../../global/typography");
exports.MuiPaginationItem = {
    root: {
        fontSize: typography_1.typography.pxToRem(14),
        fontWeight: 600,
    },
};
